import React, { Component } from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import AnimationContainer from '../FadeAnimation';
import Slider from '../Slider';
import Lable from './Lable';
// import LikeCounter from '../LikeCounter';

export class CaseWithSlider extends Component {
    render() {
        const {
            className,
            caseData: {
                poster,
                description,
                uuid,
                directions,
            },
            handleOpen,
        } = this.props;

        return (
            <Root className={className}>
                <Slider handleOpen={handleOpen} slides={poster} uuid={uuid} />
                <LablesStyled
                    directions={directions}
                />
                <Text>
                    {description ? parse(description) : null}
                </Text>
            </Root>
        );
    }
}

const Text = styled.div`
    margin-top: 8px;
    margin-bottom: 8px;

    font-size: 16px;
    line-height: 24px;

    p {
        margin-top: 0px;
        word-break: break-word;
    }

    a {
        text-decoration: none;
        color: rgb(0, 50, 160, 0.64);
        cursor: pointer;
    }

    ${mediaWidth.m} {
        margin-bottom: 12px;
    }
`;

const Root = styled(AnimationContainer)`
    width: 328px;
    display: flex;
    flex-direction: column;

    ${mediaWidth.m} {
        width: 320px;
    };

    ${mediaWidth.l} {
        width: 283px;
    };

    ${mediaWidth.xl} {
        width: 404px;
    };
`;

const LablesStyled = styled(Lable)`
    margin-top: 12px;
`;

export default CaseWithSlider;
